let mobilecheck = function () {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};

let landscapeCheck = function () {
    return !mobilecheck() || (window.innerWidth > window.innerHeight);
}

let checkWidthScreen = function () {
    let change = false;
    if (window.innerWidth < 769) {
        if (!isMobileScreen) {
            isMobileScreen = true;
            change = true;
        }
    } else {
        if (isMobileScreen) {
            isMobileScreen = false;
            change = true;
        }
    }
    return change ;
}

let hasFullscreenEnabled = function () {
    return window.document.fullscreen
      || window.document.mozFullScreen
      || window.document.webkitFullscreen
      || window.document.msFullscreen
};

window.hasFullscreenEnabled = hasFullscreenEnabled;

let orientationCheck = function () {
    let landscapeCheckResult = landscapeCheck();
    if ( landscapeCheckResult !== isLandScape) {
        isLandScape = !isLandScape; 
        if (landscapeCheckResult) {
            document.getElementById('floating-elements').classList.remove('active');                
            if (flipBook && flipBook.target && flipBook.target.pageMode === DFLIP.PAGE_MODE.SINGLE) {
                flipBook.setPageMode(DFLIP.PAGE_MODE.DOUBLE);
            }
        } else if (!landscapeCheckResult) {
            document.getElementById('floating-elements').classList.add('active');                
            if (flipBook && flipBook.target && flipBook.target.pageMode === DFLIP.PAGE_MODE.DOUBLE) {
                flipBook.setPageMode(DFLIP.PAGE_MODE.SINGLE);
            }
        };
    }
    if (checkWidthScreen() && isMobileScreen) {
        let $menuOpen = $('.df-thumb-container.df-sidemenu-visible.df-sidemenu');
        if ($menuOpen && $menuOpen.length > 0) {
            flipBook.ui.thumbnail.trigger("click");
        }
    }
    if (!hasFullscreenEnabled() && fullScreen) {
        fullScreen = false;
        $('.df-floating .df-ui-controls').removeClass('fullscreen');
        $('.full-view').removeClass('fullscreen');
    } else if (hasFullscreenEnabled() && !fullScreen) {
        fullScreen = true;
        $('.df-floating .df-ui-controls').addClass('fullscreen');
        $('.full-view').addClass('fullscreen');
    }
}
let fullScreen = false;
let options = null;
let flipBook = null;
let isLandScape = landscapeCheck();
let isMobileScreen = null;
let $;


let initJquery = () => {
    initCss();
    let script = document.createElement('script');
    script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js';
    script.type = 'text/javascript';
    script.onload = function() {
        $ = window.jQuery;
        initDFLIP();
    };
    document.getElementsByTagName('head')[0].appendChild(script);
};

let initCss = () => {
    let link = document.createElement('link');
    link.href = '../../assets/dflip/css/dflip.min.css';
    link.type = "text/css";
    link.rel = "stylesheet";
    link.media = "screen, print";
    let link2 = document.createElement('link')
    link2.href = '../../assets/dflip/css/themify-icons.min.css'
    link2.type = "text/css";
    link2.rel = "stylesheet";
    link2.media = "screen, print";

    document.getElementsByTagName('head')[0].appendChild(link);
    document.getElementsByTagName('head')[0].appendChild(link2);
}

let initHammer = () => {
    let script = document.createElement('script');
    script.src = '../../assets/hammer.min.js';
    script.type = 'text/javascript';
    script.onload = function() {
        initPdfReader();
    };
    document.getElementsByTagName('head')[0].appendChild(script);
};

let initDFLIP = () => {
    let script = document.createElement('script');
    script.src = '../../assets/dflip/js/dflip.min.js';
    script.type = 'text/javascript';
    script.onload = function() {
        if (mobilecheck()) {
            initHammer();
        } else {
            initPdfReader();
        }
    };
    document.getElementsByTagName('head')[0].appendChild(script);
};

let initPdfReader = () => {
    if (mobilecheck()) {
        document.getElementById('zoom-container').classList.add('mobile');
    }
    const source = '../res/pdf/cromotopia-de-caro.pdf';
    options = {
        threejsSrc: 'dflip/js/libs/',
        //sets if to use 3d or not (true|false)
        webgl: true,
        //if you want to turn of shadow in 3d set it to false
        webglShadow: false,
        // if enable sound at start (true|false)
        soundEnable: false,
        // set to true to show outline on open (true|false)
        autoEnableOutline: false,
        // set to true to show thumbnail on open (true|false)
        autoEnableThumbnail: false,
        // set to true if PDF inbuilt outline is to be removed (true|false)
        overwritePDFOutline: false,
        // enableDownload of PDF files (true|false)
        enableDownload: true,
        // duration of page turn in milliseconds
        duration: 800,
        //direction of flipbook
        //DFLIP.DIRECTION.LTR or 1  for left to right(default),
        //DFLIP.DIRECTION.RTL or 2  for right to left,
        direction: DFLIP.DIRECTION.LTR,
        //set as
        //DFLIP.PAGE_MODE.AUTO           for auto-detect(default),
        //DFLIP.PAGE_MODE.SINGLE or 1       for singleview,
        //DFLIP.PAGE_MODE.DOUBLE or 2       for doubleview,
        pageMode: landscapeCheck() ? DFLIP.PAGE_MODE.DOUBLE : DFLIP.PAGE_MODE.SINGLE,
        //set as
        //DFLIP.SINGLE_PAGE_MODE.AUTO           for auto-detect(default),
        //DFLIP.SINGLE_PAGE_MODE.ZOOM or 1         for normal zoom single view,
        //DFLIP.SINGLE_PAGE_MODE.BOOKLET or 2       for Booklet mode,
        singlePageMode: DFLIP.SINGLE_PAGE_MODE.AUTO,
        //color value in hexadecimal
        backgroundColor: "#ccc",
        forceFit: true, //very rare usage leave it as true unless page are not fitting wrong...
        transparent: false, //true or false
        hard: "none", //possible values are "hard", "none", "cover"
        autoPlay: false,
        width: '100%',
        height: '100%',
        // texture settings
        maxTextureSize: 1024,  //max page size to be rendered. for pdf files only
        minTextureSize: 256,  //min page size to be rendered. for pdf files only
        rangeChunkSize: 524288,
        // icons for the buttons
        icons: {
        'altnext': 'ti-angle-right',
        'altprev': 'ti-angle-left',
        'next': 'ti-angle-right',
        'prev': 'ti-angle-left',
        'end': 'ti-angle-double-right',
        'start': 'ti-angle-double-left',
        'share': 'ti-sharethis',
        'help': 'ti-help-alt',
        'more': 'ti-more-alt',
        'download': 'ti-download',
        'zoomin': 'ti-zoom-in',
        'zoomout': 'ti-zoom-out',
        'fullscreen': 'ti-fullscreen',
        'fitscreen': 'ti-arrows-corner',
        'thumbnail': 'ti-layout-grid2',
        'outline': 'ti-menu-alt',
        'close': 'ti-close',
        'doublepage': 'ti-book',
        'singlepage': 'ti-file',
        'sound': 'ti-volume',
        'facebook': 'ti-facebook',
        'google': 'ti-google',
        'twitter': 'ti-twitter-alt',
        'mail': 'ti-email',
        'play': 'ti-control-play',
        'pause': 'ti-control-pause'
        },
        // TRANSLATION text to be displayed
        text: {
        toggleThumbnails: "Mostrar/Ocultar Miniaturas",
        toggleOutline: "Toggle Outline/Bookmark",
        previousPage: "Página anterior",
        nextPage: "Página siguiente",
        toggleFullscreen: "Entrar/salir pantalla completa",
        zoomIn: "Acercar",
        zoomOut: "Alejar",
        toggleHelp: "Mostrar/Ocultar ayuda",
        singlePageMode: "Modo de una página",
        doublePageMode: "Modo libro",
        downloadPDFFile: "Descargar como PDF",
        gotoFirstPage: "Ir al inicio",
        gotoLastPage: "Ir al final",
        play: "Comenzar",
        pause: "Pausar",
        share: "Compartir"
        },
        //valid controlnames:
        //altPrev,pageNumber,altNext,outline,thumbnail,zoomIn,zoomOut,fullScreen,share
        //more,download,pageMode,startPage,endPage,sound
        allControls: "pageMode, pageNumber,play,zoomIn,zoomOut,startPage,endPage",
        // moreControls: "download,pageMode",
        hideControls: "",
        controlsPosition: DFLIP.CONTROLSPOSITION.BOTTOM,
        paddingTop: 20,
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 0,
        //set if the zoom changes on mouse scroll (true|false)
        scrollWheel: false,
        // callbacks
        onCreate: function (flipBook) {
        },
        onCreateUI: function (flipBook) {
        // after ui created event is fired
        },
        onFlip: function (flipBook) {
        // after flip event is fired
        },
        beforeFlip: function (flipBook) {
        // before flip event is fired
        },
        onReady: (flipBook) => {
            onCreateFunction();
        // after flip book is completely loaded
        },
        zoomRatio: 1.5,
        pageSize: DFLIP.PAGE_SIZE.AUTO,
        enableAnnotation: false,
        pdfRenderQuality: 1,
        /**
        * Let them be, change at your risk
        */
        // if texture fallback override is required
        // note: if set to anything other than "blank" the first page is changed
        // recommended : "blank"
        textureLoadFallback: "blank", //"images/textures/white.jpg",
        // controls the flexibility of the paper more value for more flexiblilty
        // or any number like 5, 500. recommended: "auto"
        /*3D settings*/
        spotLightIntensity: 0.22,
        ambientLightColor: "#fff",
        ambientLightIntensity: 0.8,
        shadowOpacity: 0.15
    };
    flipBook = $("#pdf").flipBook(source, options);
    window.flip = flipBook;
    if (!landscapeCheck()) {
        $('#floating-elements').addClass('active');
    };
    checkWidthScreen();
    $(window).bind("resize", orientationCheck);
    let onCreateFunction = () => {
        if (mobilecheck()) {
            eventElement = $('canvas')[0];
            let hammerController = new Hammer.Manager(eventElement);
            let DoubleTap = new Hammer.Tap({event: 'doubletap', taps: 2 });
            hammerController.add(DoubleTap);
            hammerController.on('doubletap', function(e) {
                if (flipBook.zoomValue >= 2.4) {
                    flipBook.zoom(-1.5);
                    flipBook.zoom(-1.5);
                    flipBook.zoom(-1.5);
                } else {
                    flipBook.zoom(1.5);
                }
            });
            hammerController.on('swipeleft', (ev) => {
                if (flipBook.zoomValue === 1) {
                    flipBook.next();
                }
            });
            hammerController.on('swiperight', (ev) => {
                if (flipBook.zoomValue === 1) {
                    flipBook.prev();
                }
            });
        }
        let toogleFullScreen = () => {
            let eventElement = window.document.getElementById('zoom-container');
            if (hasFullscreenEnabled()) {
                if (window.document.exitFullscreen) {
                    window.document.exitFullscreen();
                } else if (window.document.mozCancelFullScreen) { /* Firefox */
                    window.document.mozCancelFullScreen();
                } else if (window.document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                    window.document.webkitExitFullscreen();
                } else if (window.document.msExitFullscreen) { /* IE/Edge */
                    window.document.msExitFullscreen();
                }
            } else {
                if (eventElement.requestFullscreen) {
                    eventElement.requestFullscreen();
                } else if (eventElement.mozRequestFullScreen) { /* Firefox */
                    eventElement.mozRequestFullScreen();
                } else if (eventElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                    eventElement.webkitRequestFullscreen();
                } else if (eventElement.msRequestFullscreen) { /* IE/Edge */
                    eventElement.msRequestFullscreen();
                }
            }
        }
        $('.full-view').addClass('visible');
        $('.full-view').bind('click', toogleFullScreen);
    }
};